<template>
  <div id="compRenderer">
    <!--add click methods to the icons below-->
    <div class="action-btns-box">
      <router-link :to="`/compliance/update/${data.row.id}`">
        <i class="mdi mdi-pencil mr-3 action-icon"></i>
      </router-link>
      <i class="mdi mdi-delete action-icon" @click="onDeleteCompliance()"></i>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["data"],
  methods: {
    ...mapActions("compliance", ["deleteCompliance"]),
    onDeleteCompliance() {
      this.$bvModal
        .msgBoxConfirm(
          `${this.$t('common.notes.areYouSureYouWant')} ${this.$t('common.delete')} ${this.data.row.name}?`,
          {
            title: this.$t("common.confirmation"),
            size: "md",
            buttonSize: "md",
            okVariant: "primary",
            cancelVariant: "outline-secondary",
            okTitle: this.$t("common.confirm"),
            cancelTitle: this.$t("common.cancel"),
            headerClass: "p-2 border-bottom-0 h1",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        )
        .then((proceed) => {
          if (proceed) {
            this.deleteCompliance(this.data.row.id).then(() => {
              this.$emit("deleteComplianceEvent");
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
#compRenderer {
  .modal-body {
  font-size: 18px;
  font-weight: bold;
}
  .action-btns-box i {
    font-size: 1.4rem;
    color: rgba(0, 0, 0, 0.38);
    cursor: pointer;
    &:hover {
      color: #103f5e;
    }
  }
}
</style>
